import { useEffect, useMemo, useState } from 'react';

const MOBILE_TRESHOLD = 768;

export const useWindowSize = () => {
	const [width, setWidth] = useState<number>(window.innerWidth);
	const [height, setHeigth] = useState<number>(window.innerHeight);
	function handleWindowSizeChange() {
		setWidth(window.innerWidth);
		setHeigth(window.innerHeight);
	}
	useEffect(() => {
		window.addEventListener('resize', handleWindowSizeChange);
		return () => {
			window.removeEventListener('resize', handleWindowSizeChange);
		};
	}, []);

	const isMobile = useMemo(() => {
		return width <= MOBILE_TRESHOLD;
	}, [width]);

	return {
		width,
		height,
		isMobile
	};
};
